import { Text as d } from "./atoms-v243.js";
import { breakpoints as i } from "./atoms-v2125.js";
import t from "styled-components";
import { SkeletonShared as n } from "./atoms-v21000.js";
const a = t.div`
  align-items: center;
  border: 1px solid ${({ $colorTheme: e, theme: o }) => o.get(`tokens.border.${e}.light`)};
  border-radius: ${({ theme: e }) => e.get("tokens.radius.cardRadiusMed")}px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 16px 8px 16px 24px;
  width: 100%;

  @media ${i.medium} {
    padding: 24px;
  }
`, c = t.div`
  align-items: center;
  display: flex;
  flex-direction: column;

  @media ${i.medium} {
    flex-direction: row;
    gap: 16px;
  }
`, l = t.div`
  align-items: flex-start;
  display: flex;
  height: 24px;
  justify-content: flex-start;
  width: 100%;

  @media ${i.medium} {
    align-items: center;
    height: 46px;
    justify-content: center;
    width: 85px;
  }
`, x = t.div`
  display: flex;
  flex-direction: column;

  @media ${i.medium} {
    gap: 2px;
  }
`, g = t(d)`
  color: ${({ $colorTheme: e, theme: o }) => o.get(`tokens.text.${e}.primary`)};
  ${({ theme: e }) => e.get("tokens.body.productive").toJS()}

  @media ${i.medium} {
    ${({ theme: e }) => e.get("tokens.body.expressive").toJS()}
  }
`, u = t(d)`
  color: ${({ $colorTheme: e, theme: o }) => o.get(`tokens.text.${e}.secondary`)};
  ${({ theme: e }) => e.get("tokens.helper.productive").toJS()}

  @media ${i.medium} {
    ${({ theme: e }) => e.get("tokens.body.productive").toJS()}
  }
`, f = t.div`
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: center;

  @media ${i.medium} {
    gap: 24px;
  }
`, $ = t(n)`
  height: 100%;
  width: 100%;
`;
export {
  a as Container,
  l as IconFrame,
  c as LeftSide,
  $ as PictureSkeleton,
  f as RightSide,
  u as SubTitle,
  x as TextContainer,
  g as Title
};
